<template>
<div >
  <div class="row">
    <div class="col-12">
    <h3 class="page-heading">Owner Info</h3>
    <p>Manage Users</p>
    </div>
  </div>
  <div>
    <v-card>
      <v-data-table
        :headers="headers"
        :items="teams"
        :search="search"
      >
      <template v-slot:items="props">

        <td>{{ props.item.name }}</td>
        <td>{{ props.item.formatedCreatedAt }}</td>
        <td>{{ props.item.member }}</td>
        <td><v-select
          :items="roles"
          outlined
          v-model="props.item.role"
          @change="updateMemberRole(props.item)"
        ></v-select></td>
        <td><v-btn color="grey lighten-1" type="button" @click="removeMember(props.item)">Remove</v-btn></td>
      </template>
      </v-data-table>
    </v-card>
	</div>
  <div class="mt-50">
    <v-card>
      <form>
        <v-card-text>
          <v-container fluid grid-list-sm style="padding-top:0px">
            <v-layout wrap>
              <v-flex xs12>
                <v-combobox
                  v-model="members"
                  :search-input.sync="search"
                  hide-selected
                  label="Invite Members"
                  multiple
                  persistent-hint
                  small-chips
                  clearable
                >
                  <template v-slot:no-data>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>
                          No results matching "<strong>{{ search }}</strong>". Press <kbd>enter</kbd> to create a new one
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-combobox>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                  filled
                  auto-grow
                  label="Message"
                  rows="4"
                  row-height="30"
                  shaped
                  v-model="message"
                ></v-textarea>
              </v-flex>
              <v-flex xs12>
                <v-select
                  :items="roles"
                  outlined
                  v-model="role"
                ></v-select>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green lighten-1" type="button" @click="sendInvite()">Send Invite</v-btn>
        </v-card-actions>
      </form>
    </v-card>
  </div>
</div>
</template>

<script>
import {db} from '../firebaseDB'
import moment from 'moment'
export default {
  data () {
    return {
      teams: [],
      search: '',
      headers: [
          {text: 'User Name', value: 'name'},
          { text: 'Date Created', value: 'formatedCreatedAt' },
          { text: 'User Emails', value: 'member' },
          { text: 'Roles', value: 'role' },
          { text: '', value: '' }
      ],
      roles: ['Owner', 'Member'],
      members: [],
      message: ''
    }
  },
  components: {},
  created () {
    this.initialize()
  },
  mounted () {
    console.log(this.$store.state.user)
  },
  methods: {
    initialize () {
      db.ref(`team_members`).orderByChild('createdAt')
      .once('value')
        .then(snapshot => {
          let temp = []
          Object.keys(snapshot.val())
            .forEach((k) => {
              let row = Object.assign(snapshot.val()[k],
                {
                  id: k,
                  formatedCreatedAt: snapshot.val()[k].createdAt ? moment(snapshot.val()[k].createdAt).format('MMMM Do, YYYY') : null,
                  formatedUpdatedAt: snapshot.val()[k].updatedAt ? moment(snapshot.val()[k].updatedAt).format('MMMM Do, YYYY') : null
                })
            //  temp.push(row)
            })
          return temp
        })
        .catch(error => {
          console.log('Error - ' + error.message)
        }).then(snapshot => {
          this.teams = snapshot
          console.log(this.teams)
        })
    },
    updateMemberRole (item) {
      db.ref(`team_members/` + item.id).set({
        member: item.member,
        role: item.role,
        createdAt: item.createdAt,
        createdBy: item.createdBy,
        updatedAt: moment().format('YYYY-MM-DD')
      })
      this.initialize()
    },
    sendInvite () {
      let self = this
      window.Email.send({
        Host: 'smtp.mailtrap.io',
        Username: 'f31635284629ca',
        Password: '4103b8dcdb0d10',
        To: this.members,
        From: this.$store.state.user.email,
        Subject: 'This is the subject',
        Body: this.message
      }).then(function (message) {
        if (confirm('Successfully invited the members')) {
          self.members.forEach(member => {
            db.ref('team_members').push({
              member: member,
              role: 'Owner',
              createdAt: moment().format('YYYY-MM-DD'),
              createdBy: self.$store.state.user.id,
              updatedAt: null
            })
          })
          self.members = []
          self.message = ''
          self.initialize()
        }
      })
    },
    removeMember (item) {
      db.ref(`team_members/` + item.id).remove()
      this.initialize()
    }
  }
}
</script>
<style scoped>
.btn {
  margin: 5px;
}
.active{
  background-color: #47b784 !important;
  color: #fff;
}

.btn-toggle {
  top: 50%;
  transform: translateY(-50%);
  background-color: #bdc1c8;
}

.btn-toggle.btn-xs {
    margin: 0 0;
    padding: 0;
    position: relative;
    border: none;
    height: 1rem;
    width: 2rem;
    border-radius: 1rem;
}

.btn-toggle.btn-xs > .handle {
    position: absolute;
    top: 0.125rem;
    left: 0.125rem;
    width: 0.75rem;
    height: 0.75rem;
    border-radius: 0.75rem;
    background: #fff;
    transition: left 0.25s;
}

.table-responsive {
    display: inline-table;
}

.mt-50 {
  margin-top: 50px;
}

.theme--light.v-btn {
  background-color: #fff !important;
  color: #47b784 !important;
}

.green{
  border-color: #47b784 !important;
  border: 2px solid;
}
</style>



// WEBPACK FOOTER //
// src/views/ManageUsers.vue